//JS for the pathways-finder and pathways-finder-results pages
var PATHWAYS_SORT_ORDER_COURSE_NAME_ASC = "AZ";
var PATHWAYS_SORT_ORDER_COURSE_NAME_DESC = "ZA";
var PATHWAYS_SORT_ORDER_ATAR_ASC = "ATAR_asc";
var PATHWAYS_SORT_ORDER_ATAR_DESC = "ATAR_desc";

var selected_pathways_finder_value = "";
var pathways_finder_present = false;
var pathways_finder_results_present = false;
var pathways_results_page_size = 18;
var pathways_results_total_pages = 1;

var search_filters = {studyArea: "all", atarMin: 0, atarMax: -1};
var sorting_method = "suggested";

var pathways_courses_data = [];

//Handlebars Helpers
Handlebars.registerHelper('times', function(n, block) {
    //This helper is a basic for loop
    //Example use:
    //  {{#times numberOfPages}}
    // 		{{#if @first}}
    // 			<a class="paginator_page paginator_page--selected" href="#">{{@index}}</a>
    // 		{{else}}
    // 			<a class="paginator_page" href="#">{{@index}}</a>
    // 		{{/if}}
    // 	{{/times}}
    var accum = '';
    for(var i = 0; i < n; ++i) {
        block.data.index = i;
        block.data.indexOffset = i + 1; //in case we don't want to use a 0-indexed thingo
        block.data.first = i === 0;
        block.data.last = i === (n - 1);
        accum += block.fn(this);
    }
    return accum;
});

Handlebars.registerHelper('testAtar', function(atarValue) {
    if($.isNumeric(atarValue)) {
        return "<div>"+atarValue+"</div>";
    } else {
        return "<div class=\"pathways-finder-results__atar--small\">"+atarValue+"</div>";
    }
});

$(document).ready(function () {
    checkForPathwaysComponents();

    if(pathways_finder_present) {
        $(".pathways-finder-search-button").on("click", function (e) {
            e.preventDefault();
            var button_clicked = $(this);
            var button_href = button_clicked.prop("href");

            if(button_clicked.hasClass("target_other")) {
                var separator = button_href.indexOf('?') !== -1 ? "&" : "?";
                window.location = button_href+separator+"q="+selected_pathways_finder_value;
            } else {
                if(pathways_finder_results_present) {
                    updateResults();
                }
            }
        });
        $(".pathways-finder__select").change(function() {
            setStudyAreaFromDropdown($(this))
            if(pathways_finder_results_present) {
                updateResults();
            }
        });
        autoSelectDropdownFromQueryString();
    }
    if(pathways_finder_results_present) {
        updateResults();
        var order_selector_dropdown = $(".pathways-finder-results__view-selector .view_dropdown");
        order_selector_dropdown.change(function() {
            var selected_option = $(this).find("option:selected");
            sorting_method = selected_option.val();
            updateResults();
        });

        //ATAR filters
        $(".pathways-finder-results__atar-filter-item_sub").on("click", function (e) {
            e.preventDefault();
            var selected_class = "pathways-finder-results__atar-filter-item_sub--selected";
            var all_atar_buttons = $(".pathways-finder-results__atar-filter-item_sub");
            var button_clicked = $(this);

            if(button_clicked.hasClass(selected_class)) {
                button_clicked.removeClass(selected_class);
            } else {
                all_atar_buttons.removeClass(selected_class);
                button_clicked.addClass(selected_class);
            }
            updateSearchFilters();
            updateResults();
        });
    }

});

function setStudyAreaFromDropdown(dropdown_element) {
    selected_pathways_finder_value = dropdown_element.find("option:selected").val();
    search_filters.studyArea = selected_pathways_finder_value;
}

function checkForPathwaysComponents() {
    if($(".pathways-finder").length > 0) {
        pathways_finder_present = true;
    }
    if($(".pathways-finder-results").length > 0) {
        pathways_finder_results_present = true;
    }
}
//Borrowed from Sajari because it works
var get_hash_value = function(e){var t = new RegExp("[?&]" + e.replace(/[\[\]]/g, "\\$&") + "(=([^&#]*)|&|#|$)"),a = t.exec(window.location.href);return a && a[2] ? decodeURIComponent(a[2].replace(/\+/g, " ")) : ""};

function autoSelectDropdownFromQueryString() {
    var q = get_hash_value("q");
    var pathways_finder_select = $(".pathways-finder__select").first();
    var valid_study_area = false;
    if(q && q.length > 0) {

        pathways_finder_select.find("option").each(function(){
            if($(this).val() === q) {
                valid_study_area = true;
                return false; //this is how you break out of each() in jquery apparently, returning true is a continue
            }
        });
        if(valid_study_area) {
            pathways_finder_select.val(q).prop('selected', true);
        }
    }
    if(pathways_finder_results_present) {
        setStudyAreaFromDropdown(pathways_finder_select);
    }

}

function updateSearchFilters() {
    //look for atars
    var selected_atar_filter = $(".pathways-finder-results__atar-filter-item_sub--selected");
    if(selected_atar_filter.length > 0) {
        search_filters.atarMin = selected_atar_filter.data("minvalue");
        search_filters.atarMax = selected_atar_filter.data("maxvalue");
    } else {
        search_filters.atarMin = 0;
        search_filters.atarMax = -1;

    }
}

function updateResults() {
    if(pathways_courses_data.length > 0) {
        populateList(sortAndFilterCoursesData(pathways_courses_data));
    } else {
        getCoursesJson();
    }
}

function getCoursesJson() {
    //TODO (JD) probably need some good error handling here...
    $.ajax({
        method: "GET",
        url: '/flinders-services/courses.json/tagFilters.flinders:course/study_type/undergraduate.tagFilters.flinders:course/availability/domestic.json',
    }).done(function (data){
        pathways_courses_data = data;
        populateList(sortAndFilterCoursesData(data));

    });
}
function populateList(data) {
    //Note: Instead of doing something fancy here, we are simply blowing away all items and adding them again in the order we want.
    var results_container = $("#results_container");
    results_container.empty();
    var list_template = $("#pathways_finder_result_item_template").html();

    var template = Handlebars.compile(list_template);
    var html = template({
        courses: data
    });
    results_container.append(html);

    //Add title attributes to the links that dont have them!
    var all_pathways_options = results_container.find('.pathways_option');
    all_pathways_options.prop("title", function() {
        return $(this).text();
    });
    //set ellipsis items
    all_pathways_options.ellipsis({
        lines: 1,
        ellipClass: 'pathways-finder-results__ellipsis',
        responsive: true
    });

    initPaginator(data.length);
    initSortableHeadings();
}

function sortAndFilterCoursesData(courses) {
    courses = courses.filter(function(course) {
        var study_area_filter_bool = false;
        var atar_min_filter_bool = true;
        var atar_max_filter_bool = true;
        var atar_score_to_compare = parseFloat(course.atarCutoff);
        var current_course_tags = course.tags;
        //Go through each filter in the object
        for (var key in search_filters) {
            if(key === "studyArea") {
                var study_area = search_filters[key];
                if(study_area !== "all") {
                    var study_area_tag_prefix = "flinders:course/study_area/";
                    if(jQuery.inArray((study_area_tag_prefix+study_area), current_course_tags) !== -1) {
                        study_area_filter_bool = true;
                    }
                } else {
                    //else all
                    study_area_filter_bool = true;
                }
            }
            if(key === "atarMin") {
                var current_atar_min_value = parseFloat(search_filters[key]);
                if(current_atar_min_value > 0) {
                    atar_min_filter_bool = atar_score_to_compare >= current_atar_min_value;
                }

            }
            if(key === "atarMax") {
                var current_atar_max_value = search_filters[key];
                if(current_atar_max_value > 0) {
                    atar_max_filter_bool = atar_score_to_compare <= current_atar_max_value;
                }
            }
        }
        return study_area_filter_bool && atar_min_filter_bool && atar_max_filter_bool;
    });
    courses = courses.sort(getSortCompareFunction(sorting_method));
    return courses;
}

function initSortableHeadings() {
    var ORDER_TYPE_COURSE_NAME = "NAME";
    var ORDER_TYPE_ATAR = "ATAR";
    var order_selector_dropdown = $(".pathways-finder-results__view-selector .view_dropdown");

    var selected_chevron_class = "pathways-finder-results__order-direction-chevron--selected";
    var all_heading_chevrons = $(".pathways-finder-results__order-direction-chevron");

    $(document).off('click.pathways_heading_sort');
    $(document).off('click.pathways_chevron_sort');

    $(".pathways-finder-results__item-heading--orderable").on("click.pathways_heading_sort", function (e) {
        e.preventDefault();
        var item_heading_clicked = $(this);
        var item_heading_order_type = item_heading_clicked.data("order-type");
        if(item_heading_order_type === ORDER_TYPE_COURSE_NAME) {
            if(sorting_method === PATHWAYS_SORT_ORDER_COURSE_NAME_ASC) {
                order_selector_dropdown.val(PATHWAYS_SORT_ORDER_COURSE_NAME_DESC).trigger('change');
            } else {
                //Default to AZ if sorting method is anything but Course name -> AZ
                order_selector_dropdown.val(PATHWAYS_SORT_ORDER_COURSE_NAME_ASC).trigger('change');
            }
        } else if(item_heading_order_type === ORDER_TYPE_ATAR) {
            if(sorting_method === PATHWAYS_SORT_ORDER_ATAR_ASC) {
                order_selector_dropdown.val(PATHWAYS_SORT_ORDER_ATAR_DESC).trigger('change');
            } else {
                //Default to ATAR_asc if sorting method is anything but ATAR -> ATAR_asc
                order_selector_dropdown.val(PATHWAYS_SORT_ORDER_ATAR_ASC).trigger('change');
            }
        } else {
            //This state shouldn't happen, but suggested is a good fallback :)
            order_selector_dropdown.val("suggested").trigger('change');
        }
    });
    all_heading_chevrons.on("click.pathways_chevron_sort", function (e) {
        e.preventDefault();
        e.stopPropagation();
        var chevron_clicked = $(this);
        var chevron_clicked_direction = chevron_clicked.data("direction");
        if(!chevron_clicked.hasClass(selected_chevron_class)) {
            order_selector_dropdown.val(chevron_clicked_direction).trigger('change');
        }
    });

    all_heading_chevrons.removeClass(selected_chevron_class);
    if(sorting_method !== "suggested") {
        all_heading_chevrons.filter('[data-direction="'+sorting_method+'"]').addClass(selected_chevron_class);
    }
}
function initPaginator(total_courses) {
    $(".pathways-finder-results__count").show();
    $(".results_count").text(total_courses);

    var pathways_paginator = $(".pathways-finder-results__paginator");
    pathways_results_page_size = parseInt(pathways_paginator.data("pagesize"));
    var current_page = pathways_paginator.data("currentpage");
    pathways_results_total_pages = Math.ceil(total_courses / pathways_results_page_size);

    pathways_paginator.data("totalpages",pathways_results_total_pages);
    $(document).off('click.paginator_prev');
    $(document).off('click.paginator_page');
    $(document).off('click.paginator_next');
    pathways_paginator.empty();

    var paginator_template = $("#pathways_finder_result_paginator_item").html();
    var template = Handlebars.compile(paginator_template);
    var html = template({
        numberOfPages: pathways_results_total_pages
    });
    pathways_paginator.append(html);

    updateResultsPages("init", 1);

    $(".paginator_prev").on("click.paginator_prev", function (e) {
        e.preventDefault();
        var paginator_button = $(this);
        if(!paginator_button.hasClass("paginator_prev--disabled")) {
            updateResultsPages("prev", 0);
        }
    });
    $(".paginator_page").on("click.paginator_page", function (e) {
        e.preventDefault();
        var paginator_button = $(this);
        var page_number = paginator_button.data("pagenumber");
        if(!paginator_button.hasClass("paginator_page--selected")) {
            updateResultsPages("jump", page_number);
        }
    });
    $(".paginator_next").on("click.paginator_next", function (e) {
        e.preventDefault();
        var paginator_button = $(this);
        if(!paginator_button.hasClass("paginator_next--disabled")) {
            updateResultsPages("next", 0);
        }
    });
}

//action = "prev" "next" or "jump"
function updateResultsPages(action, pageNumber) {
    var display_class = "pathways-finder-results__item--shown";
    var already_selected_page = $(".paginator_page.paginator_page--selected");
    var current_page_number = already_selected_page.data("pagenumber");

    var pathways_paginator = $(".pathways-finder-results__paginator");
    var current_page = pathways_paginator.data("currentpage");

    if(action === "prev") {
        var prev_page_to_select = $(".paginator_page[data-pagenumber='"+(current_page_number - 1)+"']");
        already_selected_page.removeClass("paginator_page--selected");
        prev_page_to_select.addClass("paginator_page--selected");
        updatePaginatorPrevNextButtons(prev_page_to_select.data("pagenumber"));

    } else if(action === "next") {
        var next_page_to_select = $(".paginator_page[data-pagenumber='"+(parseInt(current_page_number) + 1)+"']");
        already_selected_page.removeClass("paginator_page--selected");
        next_page_to_select.addClass("paginator_page--selected");
        updatePaginatorPrevNextButtons(next_page_to_select.data("pagenumber"));
    } else if(action === "jump") {
        var new_page_to_select = $(".paginator_page[data-pagenumber='"+pageNumber+"']");
        already_selected_page.removeClass("paginator_page--selected");
        new_page_to_select.addClass("paginator_page--selected");
        updatePaginatorPrevNextButtons(new_page_to_select.data("pagenumber"));
    } else {
        updatePaginatorPrevNextButtons(1);
    }
    var all_results_after_filters = $(".pathways-finder-results__item");
    all_results_after_filters.removeClass(display_class);
    var new_page_selected =  $(".paginator_page.paginator_page--selected").data("pagenumber");
    var results_to_display = all_results_after_filters.slice((new_page_selected-1)*pathways_results_page_size , new_page_selected*pathways_results_page_size);
    results_to_display.addClass(display_class);
    setupSelectionRankTooltips();
}
function updatePaginatorPrevNextButtons(pageNumber) {
    var prev_button = $(".paginator_prev");
    var next_button = $(".paginator_next");
    if(pageNumber === 1) {
        prev_button.addClass("paginator_prev--disabled");
    } else {
        prev_button.removeClass("paginator_prev--disabled");
    }
    if(pageNumber === pathways_results_total_pages) {
        next_button.addClass("paginator_next--disabled");
    } else {
        next_button.removeClass("paginator_next--disabled");
    }
}

function getSortCompareFunction(sort_method) {
    switch (sort_method) {
        case PATHWAYS_SORT_ORDER_COURSE_NAME_ASC:
            return function(a, b) {
                var nameA = a.name.toUpperCase();
                var nameB = b.name.toUpperCase();
                if (nameA < nameB) {
                    return -1;
                }
                if (nameA > nameB) {
                    return 1;
                }
                return 0;
            };
        case PATHWAYS_SORT_ORDER_COURSE_NAME_DESC:
            return function(a, b) {
                var nameA = a.name.toUpperCase();
                var nameB = b.name.toUpperCase();
                if (nameB < nameA) {
                    return -1;
                }
                if (nameB > nameA) {
                    return 1;
                }
                return 0;
            };
        case PATHWAYS_SORT_ORDER_ATAR_DESC:
            return function(a, b) {
                var atar_a = a.hasOwnProperty("atarCutoff") ? a.atarCutoff : 0;
                if(!$.isNumeric(atar_a)) {
                    atar_a = 0;
                }
                var atar_b = b.hasOwnProperty("atarCutoff") ? b.atarCutoff : 0;
                if(!$.isNumeric(atar_b)) {
                    atar_b = 0;
                }

                return atar_b - atar_a;
            };
        case PATHWAYS_SORT_ORDER_ATAR_ASC:
            return function(a, b) {
                var atar_a = a.hasOwnProperty("atarCutoff") ? a.atarCutoff : 0;
                if(!$.isNumeric(atar_a)) {
                    atar_a = 0;
                }
                var atar_b = b.hasOwnProperty("atarCutoff") ? b.atarCutoff : 0;
                if(!$.isNumeric(atar_b)) {
                    atar_b = 0;
                }
                return atar_a - atar_b;
            };
        default:
            return function(a, b) {
                var nameA = a.name.toUpperCase();
                var nameB = b.name.toUpperCase();
                var a_promoted = a.hasOwnProperty("promoted") ? a.promoted : false;
                var b_promoted = b.hasOwnProperty("promoted") ? b.promoted : false;
                var a_priority = parseInt(a.priority);
                var b_priority = parseInt(b.priority);
                //If a or b priority are not numbers, treat them as 0
                if(isNaN(a_priority)) {
                    a_priority = 0;
                }
                if(isNaN(b_priority)) {
                    b_priority = 0;
                }

                //Order by: promoted (bool) = true , priority (float) high > low , name (String) A > Z
                //If both are promoted, or both are not promoted, do this
                if (a_promoted === b_promoted) {
                    if(b_priority !== a_priority) {
                        //If there is a difference in priority, return the difference.
                        return b_priority - a_priority;
                    } else {
                        if (nameA < nameB) {
                            return -1;
                        }
                        if (nameA > nameB) {
                            return 1;
                        }
                        return 0;
                    }
                } else {
                    //If one is promoted and the other is not
                    return a_promoted ? -1 : 1;
                }
            };
    }
}

function setupSelectionRankTooltips() {
    var all_selection_rank_tooltips = $(".atar_tooltip_icon");
    var tooltip_template = '<div class="tooltip ff_tooltip" role="tooltip"><div class="tooltip-arrow"></div><div class="tooltip-inner"></div></div>';

    all_selection_rank_tooltips.on("click focus", function (e) {
        e.preventDefault();
        return false;
    });
    //Apply tooltip settings
    all_selection_rank_tooltips.tooltip({animation: true, container: '.fast_facts_tooltip_icon',placement:'top',trigger:"click hover focus", template: tooltip_template});
}
